import Link from "next/link";
import Image from "next/image";
import type { Scene } from "@/lib/types";
import CategoryBadge from "@/components/ui/CategoryBadge";
import { displayCommune, displayTitle, getEditorial } from "@/lib/editorial";
import { thumbUrl } from "@/lib/images";

/**
 * Carte-lieu du catalogue et des listes. Mène à la fiche indexable
 * (jamais directement au lecteur : le panorama se charge à la demande).
 */
export default function SceneCard({ scene }: { scene: Scene }) {
  const editorial = getEditorial(scene.slug);
  return (
    <Link
      href={`/lieux/${scene.slug}/`}
      className="group block overflow-hidden rounded-2xl bg-anthracite transition-shadow hover:shadow-xl hover:shadow-black/40"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <Image
          src={thumbUrl(scene.slug)}
          alt={`Aperçu du panorama : ${displayTitle(scene)}`}
          fill
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
          className="object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2.5 left-2.5">
          <CategoryBadge categoryId={scene.category} />
        </div>
      </div>
      <div className="px-4 py-3.5">
        <p className="font-serif text-[17px]">{displayTitle(scene)}</p>
        {displayCommune(scene) && (
          <p className="mt-0.5 text-xs text-mineral">{displayCommune(scene)}</p>
        )}
        {editorial && (
          <p className="mt-2 line-clamp-3 text-[12.5px] leading-relaxed text-corail/70">
            {editorial.shortDescription}
          </p>
        )}
      </div>
    </Link>
  );
}
